import { Widget } from '@/modules/ta/widget/models/Widget';
import { User } from '@/modules/ta/user/models/User';
import { WidgetDataCache } from '@/modules/ta/widget/caches/WidgetDataCache';

export class AccountManagerWidget extends Widget {
  /**
   * userId to download
   */
  accountManagerId;

  constructor(model) {
    super(model);

    if (this.metadata.dynamic.predefined_data?.data) {
      WidgetDataCache.set(this.id, new User(this.metadata.dynamic.predefined_data.data));
    }
  }
}
